export default __webpack_public_path__ + "static/media/grill.99c53ae1.svg";